import styles from "./styles.module.scss";

import { ReactComponent as AttachmentIcon } from "icons/attachmentIcon.svg";
export const AttachFile = () => {
  return (
    <div className={styles.attachFile}>
      <AttachmentIcon /> <span>Attach File</span>
    </div>
  );
};
